export default {
  es: {
    // B2BDetail screen
    ERROR_LOAD_B2B_DETAIL: 'Ups! Ocurrió un problema al cargar los datos.',
    RETRY_AGAIN_LABEL: 'Intentar de nuevo',
    // B2BLanding screen
    COURSE: 'Cursos',
    TRANSMISSIONS: 'Transmisiones',
    ERROR_LOAD_B2B_LANDING: 'Ups! Ocurrió un problema al cargar la página.',
    // Chat screen
    LOAD_CHAT: ' Cargando chat...',
    WAIT_SECONDS: 'Descuida, tomará unos segundos',
    // Detail screen
    HIDDEN_CHAT_LABEL: 'Ocultar chat',
    SHOW_CHAT_LABEL: 'Mostrar chat',
    POP_UP_CHAT_LABEL: 'Popup chat',
    HIDDEN_POP_UP_CHAT_LABEL: 'Ocultar chat popup',
    NOT_MISS_LIVE: '¡No te pierdas el siguiente Live!',
    SEE_PROGRAMMING_LABEL: 'Ver programación',
    SHEDULE_CALENDAR_LABEL: 'Agendar a calendario',
    ERROR_LOAD_DETAIL: 'Ups! Ocurrió un problema al cargar los datos.',
    // Landing screen
    ERROR_LOAD_LANDING: 'Ups! Ocurrió un problema al cargar la página.',
    // MembershipSnackbar Component
    COURSE_TO_GROW: 'Más de un curso para seguir creciendo',
    CORSE_TO_GROW_MESSAGE:
      'Estás por disfrutar una parte de nuestra experiencia de aprendizaje. ¿Quieres saber más? Descubre cómo aprender algo nuevo cada día con una membresía.',
    CORSE_TO_GROW_PREMIUM: 'Descubre Premium',
    LIVE_END:
      '¿Te gustó el live? Lleva tu experiencia más lejos con +500 cursos',
    LIVE_MESSAGE_END:
      '¡Es el momento de profundizar en lo aprendido! Descubre nuestras membresías Premium y accede a todos nuestros cursos, especializaciones, mentorías personalizadas y más.',
    LIVE_END_LABEL: '¡Me interesa!',
    // ShareDialogContent Component
    SHARE_lIVE: 'Comparte este live',
    SHARE_LIVE_DESCRIPTION:
      '¿Te gusta lo que ves? Comparte este live para que llegue a más personas',
    // VideoInfo Component
    SHARE_BUTTON_LIVE_LABEL: 'Comparte este Live',
    SIGN_UP_FREE_LABEL: '¡Inscríbete gratis!',
    SIGN_UP_LIVE_LABEL: 'Inscribirme',
    ADD_CALENDAR_LABEL: 'Añadir a mi calendario',
    // CardLeadPhone Component
    LEARN_WITHOUT_LIMITS: 'Aprende sin límites',
    DISCOUNT_COURSES:
      'Estás a una llamada de acceder al mejor descuento en 800 cursos con el mejor descuento.',
    TALK: 'Conversemos',
    // B2bFooter section
    PRODUCT_B2B: 'Este es un producto para empresas de',
    NEED_HELP: '¿Necesitas ayuda?',
    FOLLOW_US: 'Síguenos',
    COPYRIGTH: 'Todos los derechos reservados',
    // ClassroomCourseList Section
    ERROR_UPS_CLASS_ROOM_COURSE_LIST: 'Oops, Ocurrio un error',
    TITLE_CLASS_ROOM_COURSE_LIST_1: 'Cursos de',
    TITLE_CLASS_ROOM_COURSE_LIST_2: 'para ti',
    NOT_COURSES: 'Tu organización aún no tiene cursos',
    // Hero section
    CREHANA_LEARN: 'Crehana LIVE: \n Una nueva manera de aprender',
    SEE_TRANSMISSIONS: 'Ver todas nuestras transmisiones ',
    NEXT_LIVE: 'PRÓXIMO LIVE',
    PREMIUM_EXCLUSIVE: 'EXCLUSIVO PREMIUM',
    GO_TRANSMISSION: 'Ir a la transmisión',
    SEE_INFO: 'Ver más información',
    // LiveList section
    ERROR_LIVE_LIST:
      'Ups! Ocurrió un problema al intentar cargar los Crehana Lives :(',
    ENJOY_TRANSMISSION: 'Disfruta de todas nuestras transmisiones',
    DISCOVER_LIVE_KIDS: '¡Descubre nuestros Crehana Lives para niños!',
    EMPTY_CONTENT_LIVE_LIST: 'Aún no tenemos contenido para esta categoría',
    BACK_TOP_LIST: 'Regresar a la lista completa',
    // NextLives section.
    KNOW_CLASS_LIVE: 'Conoce nuestras próximas clases en vivo',
    // Categories secion
    EXPLORE_CATEGORYS: 'Explora nuestras categorías',
    // Player section
    EXCLUSIVE_CONTENT: 'Este contenido es exclusivo',
    PREMIUM_CREHANA: 'Crehana Premium',
    GO_PREMIUM: 'Vuélvete Premium',
    START_IN: 'La transmisión empezará en',
    // Information section
    ABOUT_SPEAKER_LABEL: 'SOBRE EL SPEAKER',
    DESCRIPTION_LIVE_LABEL: 'DESCRIPCIÓN DEL LIVE',
    SIGN_UP_LIVE_COURSE_LABEL: 'INSCRÍBETE A SU CURSO EN CREHANA',
    MORE_COURSE_INFO_LIVE_LABEL: 'Ver más info del curso',
    // LiveTabs section
    HIDDEN_CHAT_LIVE_LABEL: 'El chat está oculto',
    SHOW_CHAT_LIVE_LABEL: 'Mostrar chat aquí',
    ABOUT_TAB_LIVE_LABEL: 'Sobre el Live',
    QUESTION_LIVE_LABEL: 'Preguntas',
    CHAT_LIVE_LABEL: 'Chat',
    // Question section
    UPS_ERROR_LIVE_LABEL:
      'Ups! Ocurrió un error al obtener información sobre las preguntas.',
    NOT_QUESTIONS_LIVE_LABEL: 'Aún no hay preguntas destacadas',
    SEARCH_QUESTIONS_LIVE_LABEL:
      'Busca en el chat preguntas que quieras resolver luego. Seleccionalas y muévelas a esta sección. ',
    SOON_QUESTIONS_LIVE_LABEL:
      'Pronto el moderador colocará las preguntas que el speaker responderá durante el live. Recuerda votar por tu favorita',
    // Chat section
    UPS_ERROR_CHAT_LIVE:
      ' Ups! Ocurrió un error al obtener información sobre el chat.',
    LOAD_CHAT_MESSAGE: 'Descuida, tomará unos segundos',
    JOIN_CHAT: 'Únete a la conversación ',
    SIGN_UP: 'Iniciando sesión o registrándote',
    LOCKED_RULES: 'Fuiste bloqueado de este chat por incumplir las ',
    RULES_COMUNITY: 'normas de la comunidad',
    NOT_LIVE: ' . Ya no podrás participar dentro de este Live.',
    WELCOME_TO_CHAT: '¡Bienvenido a la sala de chat!',
    SEE_NEW_MESSAGES: 'Ver nuevos mensajes ',
    // MessageCard section
    RESPONSE_COMMENT_LABEL: 'Responder comentario',
    HIDDEN_QUESTION_LABEL: 'Ocultar de Preguntas',
    MOVE_QUESTION_LABEL: 'Mover a Preguntas',
    PIN_UP_COMMENT_LABEL: 'Fijar comentario',
    HIDDEN_COMMENT_LABEL: 'Ocultar comentario',
    LOCK_USER_LABEL: 'Bloquear usuario',
    MODERATOR_CHAT: 'MODERADOR DEL CHAT',
    SPEAKER: 'SPEAKER',
    // PinnedMessage
    LESS: 'menos',
    MORE: 'más',
    // TextFieldForm section
    WRITE_MESSAGE_HERE: 'Escribe tu mensaje aquí...',
    LOAD_EMOJIS: 'Cargando Emojis :)',
  },
};
